import React from "react";
import { useAppState } from "../screens/App/shared/AppState/app-state";
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import configuration from '../screens/App/shared/configuration';
import { connect } from "react-redux";
import { isValidToken } from '../screens/App/shared/utils/HelperFunctions';

// Apollo GraphQL client for Accman service API
// TODO: Replace with a generic Apollo client for all API calls for Federated GraphQL
const ApolloProviderWrapper = (props) => {

  const httpLink = new HttpLink({
    uri: (props.isLegacyGraphqlRouterEnabled ? configuration.hiveRouterUrl : configuration.fleetVendorRouterUrl) + "graphql/",
  });

  const authLink = setContext((_, { headers }) => {
    // get the authentication token from local storage if it exists
    const token = props.token;
    const requestHeaders = { ...(headers || {}) };
    delete requestHeaders.authorization;
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...requestHeaders,
        ...(isValidToken(token) ? { authorization: `Bearer ${token}` } : {}),
        'graphql-client-name': configuration.graphQLClientName,
        'graphql-client-version': configuration.graphQLClientVersion,
      }
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([
      authLink,
      httpLink
    ]),
  });

  return (
    <ApolloProvider client={client}>
      <div>
        {props.children}
      </div>
    </ApolloProvider>
  );
}
const mapStateToProps = (state) => ({
  token: state.appState.getIn(['serverData', 'shared', 'token']),
  isLegacyGraphqlRouterEnabled: state.appState.getIn(['serverData', 'shared', 'isLegacyGraphqlRouterEnabled']),
});

export default connect(mapStateToProps)(ApolloProviderWrapper);
